import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, NAV } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-maroon-deep text-cream/80 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-3 mb-5">
          <img src={SITE.logo} alt="Sober Life Foundation" className="h-14 w-14 object-contain bg-cream rounded-full p-1" />
          <span className="font-heading text-2xl text-cream">Sober Life Foundation</span>
        </div>
        <p className="text-sm leading-relaxed text-cream/60 max-w-xs">
          {SITE.trust}. A safe, dignified path to recovery for men and women.
        </p>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Explore</h4>
        <ul className="space-y-3">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm hover:text-gold transition-colors duration-300">
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Reach Us</h4>
        <ul className="space-y-4 text-sm">
          <li className="flex gap-3"><Phone size={16} className="text-sunrise shrink-0 mt-0.5" /><a href={`tel:${SITE.phoneHref}`} className="hover:text-gold transition-colors">{SITE.phone}</a></li>
          <li className="flex gap-3"><Mail size={16} className="text-sunrise shrink-0 mt-0.5" /><a href={`mailto:${SITE.email}`} className="hover:text-gold transition-colors">{SITE.email}</a></li>
          <li className="flex gap-3"><MapPin size={16} className="text-sunrise shrink-0 mt-0.5" /><span className="text-cream/60 leading-relaxed">{SITE.address.full}</span></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-cream/10 py-6 text-center text-xs text-cream/40">
      © {new Date().getFullYear()} Sober Life Foundation · A Recovery Initiative by Balkan Ji Bari Trust
    </div>
  </footer>
);
